import { Host, h } from "@stencil/core";
/**
 * @deprecated Use the `ch-combo-box-render` with `suggest = true`
 */
export class ChSuggestList {
    constructor() {
        this.label = undefined;
    }
    // 2.REFERENCE TO ELEMENTS //
    // 3.STATE() VARIABLES //
    // 4.PUBLIC PROPERTY API / WATCH'S //
    // 5.EVENTS (EMIT) //
    // 6.COMPONENT LIFECYCLE EVENTS //
    // 7.LISTENERS //
    // 8.PUBLIC METHODS API //
    // 9.LOCAL METHODS //
    // 10.RENDER() FUNCTION //
    render() {
        return (h(Host, { key: '6e582600080aeacaf2540c3a7fc47e200f40efdb' }, this.label && (h("h2", { key: 'b6f96a4ce8285533ac6ce26cb95cf7734b2c630d', id: "heading", part: "title", class: "title" }, this.label)), h("ul", { key: 'e324b3abc24b76385403a9a4776c12fbbf469943', "aria-labelledby": this.label ? "heading" : undefined, part: "list", class: "list" }, h("slot", { key: 'c1ce00770322ad3c75ad5be1b8d51cadd5f9c3a8' }))));
    }
    static get is() { return "ch-suggest-list"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-suggest-list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-suggest-list.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label"
                },
                "attribute": "label",
                "reflect": false
            }
        };
    }
}
